import React from "react";
import Page from "../../Components/Page";
import { Card, CardContent } from "@mui/material";

const ReconciliationStatus = () => {
  return (
    <Page title={"Reconciliation Status"}>
      <Card>
        <CardContent>
          <form></form>
        </CardContent>
      </Card>
    </Page>
  );
};

export default ReconciliationStatus;
